import { useEffect, useState } from 'react';
import {getAvailablePuzzleDimensions} from './api'; 
import {Modal} from 'semantic-ui-react';

export const GetNewPuzzle = ({open,onClose,onGetPuzzle})=>{
    
    const [dimensions,setDimensions] = useState([]);

    useEffect(()=>{
        (async()=>{
             const dimensions = await getAvailablePuzzleDimensions();
             setDimensions(dimensions);
        })();
    },[]);

    const dimensionList = dimensions.map(d=>{
        const val = `${d.rows}x${d.cols}` 
        return <div onClick={()=>onGetPuzzle(d.rows,d.cols)} className="dimension-list-item" key={val}>{val}</div>;
    }
    );

    return (
        <Modal open={open} onClose={onClose}>
            <Modal.Header className='dialog-header'><p style={{fontWeight:'bold',fontSize:'24px'}}> Get New Puzzle</p></Modal.Header>
            <Modal.Content>
                
                    <p className="new-puzzle-message">
                        Get a new puzzle for the size you prefer. Please select one of the dimensions listed below to get your new puzzle!
                    </p>                    
                    <div className="dimension-list">
                        {dimensionList}
                    </div>
                                                
            </Modal.Content>
        </Modal>           
                
    );
};